/* MQA 3.0 — dynamic "How it arrives" line.
   Reads the selected material (substrate), frame (art-only vs framed) and size, then shows how the
   piece ships/finishes. READ-ONLY: never touches inputs, values, the preview, or the mqa_sync contract.
   Substrate is read from the rename-proof Style-variant name on the material input
   (data-product-option-art-only: 'Art Print' | 'Rolled Canvas' | 'Stretched Canvas'). */
(function () {
  'use strict';

  var FLAT_MAX_AREA = 320; // smaller than 16x20 in => ships flat; 320 sq in and up => rolled

  function checked(name) {
    return document.querySelector('input[name="properties[' + name + ']"]:checked');
  }

  function sizeArea() {
    // Find the native option <select> whose selected value looks like WxH (Size); other options
    // (Style etc.) never parse to two dimensions.
    var sels = document.querySelectorAll('[data-section-type="product"] select[name^="options["]');
    for (var i = 0; i < sels.length; i++) {
      var m = String(sels[i].value || '').match(/(\d+(?:\.\d+)?)\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)/i);
      if (m) return parseFloat(m[1]) * parseFloat(m[2]);
    }
    return 0;
  }

  function compose() {
    var mat = checked('Material');
    var frame = checked('Frame');
    var substrate = mat ? (mat.getAttribute('data-product-option-art-only') || '') : '';
    var frameName = frame ? (frame.value || '') : '';
    var isFramed = !!frameName && !/art only/i.test(frameName);

    var isStretched = substrate === 'Stretched Canvas'; // Ready to Hang Canvas (gallery wrap)
    var isPaper = substrate === 'Art Print';             // Archival Paper Print
    var isRolledCanvas = substrate === 'Rolled Canvas';  // Archival Canvas Print

    if (isFramed) {
      if (isStretched) return 'Framed, ready to hang.';
      if (isRolledCanvas) return 'Mounted and framed, ready to hang — no plexiglass, so it is glare-free and most closely resembles the original artwork.';
      if (isPaper) return 'Framed with UV-protective plexiglass, ready to hang.';
      return 'Framed and ready to hang.';
    }
    // Unframed
    if (isStretched) return 'Gallery wrapped on 1.5" kiln-dried wood stretcher bars — mirrored edges keep the full image on the front, ready to hang.';
    var area = sizeArea();
    if (area > 0 && area < FLAT_MAX_AREA) return 'Borderless, ships in a flat mailer';
    return 'Borderless, ships rolled in a tube';
  }

  function ensureLine() {
    var line = document.getElementById('mqa-delivery-line');
    if (line) return line;
    var atc = document.querySelector('[data-section-type="product"] .product-form__cart-submit');
    if (!atc) return null;
    line = document.createElement('div');
    line.id = 'mqa-delivery-line';
    line.className = 'mqa-delivery-line';
    line.innerHTML =
      '<svg class="mqa-delivery-ic" viewBox="0 0 24 24" width="16" height="16" fill="none" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>' +
      '<span class="mqa-delivery-text"></span>';
    var anchor = atc.closest('.product-form__buttons') || atc;
    anchor.parentNode.insertBefore(line, anchor);
    return line;
  }

  // Running total above the CTA: mirror the live product price (the frame engine keeps
  // .product__price updated to the true total, so we never compute a parallel price that could drift).
  function mirrorPrice(line) {
    var src = document.querySelector('[data-section-type="product"] .product__price');
    if (!src || !line) return;
    var total = document.getElementById('mqa-running-total');
    if (!total) {
      total = document.createElement('div');
      total.id = 'mqa-running-total';
      total.className = 'mqa-running-total';
      total.innerHTML = '<span class="mqa-rt-label">Your price</span><span class="mqa-rt-value"></span>';
      line.parentNode.insertBefore(total, line);
    }
    var val = total.querySelector('.mqa-rt-value');
    var txt = (src.innerText || src.textContent || '').replace(/\s+/g, ' ').trim();
    if (txt && val.textContent !== txt) val.textContent = txt;
    if (!total.__obs && window.MutationObserver) {
      total.__obs = new MutationObserver(function () { mirrorPrice(line); });
      total.__obs.observe(src, { childList: true, subtree: true, characterData: true });
    }
  }

  function update() {
    var line = ensureLine();
    if (!line) return;
    mirrorPrice(line);
    var txt = compose();
    var span = line.querySelector('.mqa-delivery-text');
    if (span.textContent !== txt) span.textContent = txt;
  }

  document.addEventListener('change', function (e) {
    var n = e.target && e.target.name;
    if (n === 'properties[Material]' || n === 'properties[Frame]' || (n && n.indexOf('options[') === 0)) {
      setTimeout(update, 60);
    }
  });

  function boot() { update(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  [400, 900, 1800].forEach(function (ms) { setTimeout(boot, ms); });
})();
